module.exports = __webpack_public_path__ + "img/ad.fbc84214.png";